import { useEffect, useState } from 'react'
import { getHttp, postHttp } from 'src/api'
import { PATH_API } from 'src/helpers/path'
import { useAppContext } from 'src/helpers/app'

export function useCollectionsColorPalettes() {
  const [palettes, setPalettes] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const { sessionID, storeURLParameters } = useAppContext()

  const saveColorPaletteSelection = async (paletteId: string) => {
    try {
      await postHttp(PATH_API.createSessionId(), {
        sessionId: sessionID,
        colorPaletteId: paletteId,
        urlParameters: storeURLParameters ?? undefined,
      })
    } catch (error) {
      console.error('Error saving color palette selection:', error)
    }
  }

  useEffect(() => {
    setLoading(true)
    getHttp(PATH_API.getQuizSessionData)
      .then((res) => {
        const colorPalettes =
          res.data.colorPalettes?.filter((palette: any) => {
            // Filter out palettes with Pink in name
            if (palette.name.includes('Pink')) return false

            // Filter out palettes with no collections
            if (palette.collectionCount < 1) return false

            return true
          }) || []
        setPalettes(colorPalettes)
      })
      .catch(() => {
        setPalettes([])
      })
      .finally(() => setLoading(false))
  }, [])

  return { palettes, loading, saveColorPaletteSelection }
}
